module.exports = __webpack_public_path__ + "static/hut-doodle-271a20743520f927ff4449c26fd4bb77.jpg";